import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { IconicModule } from '../iconic/iconic.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { DropZoneComponent } from './drop-zone.component';

@NgModule({
  imports: [CommonModule, ButtonModule, IconicModule, TooltipModule],
  declarations: [DropZoneComponent],
  exports: [DropZoneComponent],
})
export class DropZoneModule {}
